// extracted by mini-css-extract-plugin
module.exports = {"clock":"Clock_clock__-k0QM","clock__time":"Clock_clock__time__bR96m","clock__date":"Clock_clock__date__38iJe"};